import React from "react";
import './Work.css'
import jiosaavn from '../../static/jio_saavn_logo.jpg'
import ltim from '../../static/ltimindtree_logo.jpg'
// import iitr from '../../static/indian_institute_of_technology_roorkee_logo.jpg'
import mathrithms from '../../static/mathrithms_logo.jpg'
import cimpress from '../../static/cimpress.png'
import lighthouse from '../../static/lighthouse.jpeg'

export default function Work() {
    return (
        <div>
            <div class="wrap">
                <div class="row row-2">
                    <section>
                        <img class="icon" src={cimpress} alt="sanika" />
                        <div class="details">
                            <span class="title" >Cimpress - Software Engineer
                                {/* <a href="https://drive.google.com/file/d/1g4yEbBZRFThS5BbFz5DK1zUqGDoQ93QG/view?usp=sharing" style={{ color: "#CB9D06" }}>Certificate</a> */}
                            </span>
                            <span className="date">Aug 2024-Present</span>
                        </div>
                        <p className="timeline_text" style={{ fontSize: "14px", textAlign: "left" }}>
                            <ul>
                                <li>Built and scaled high-availability backend services using NestJS (TypeScript) within the Platform team, enabling core fulfillment logistics workflows and improving system reliability and cross-service interoperability.</li>

                                <li>Improved backend performance and latency by 95% through Node.js event-loop optimization, enabling faster API response times at scale.</li>

                                <li>Designed and implemented event-driven distributed systems using AWS SQS, DLQs, and Amazon CloudWatch, increasing fault tolerance, observability, and system resilience.</li>

                                <li>Owned end-to-end system design and production deployment of role-based access control (RBAC) for a shop-floor Station Manager application on a large-scale logistics platform.</li>

                                <li>Translated product and security requirements into scalable authorization flows, aligning with enterprise access models and partnering with Product and Platform teams.</li>

                                <li>Implemented backend and data migrations to NestJS, delivering 2× faster response times, 3.5× performance improvements, and ~30% throughput gains.</li>

                                <li>Performed load and stress testing of event-driven pub/sub systems using Grafana k6, validating system stability at ~1,100 RPS.</li>

                                <li>Provided on-call production support, diagnosing and resolving P0/P1 incidents to maintain high availability of mission-critical logistics services.</li>
                            </ul>
                        </p>
                    </section>
                </div>
                <div class="row row-1">
                    <section>
                        <img class="icon" src={lighthouse} alt="sanika" />
                        <div class="details">
                            <span class="title">Voluteer @ Lighthouse Project <a href="https://drive.google.com/file/d/1EuMb8SOk0SRM1LMBcR3QWE-MccKKzl7G/view" style={{ color: "#CB9D06" }}>Certificate</a></span>
                            <span className="date">Aug 2024-Jan 2026 </span>
                        </div>
                        <p className="timeline_text" style={{ fontSize: "14px", textAlign: "left" }}>
                            <ul>
                                <li>
                                    Mentored under-resourced students at BMC schools.
                                </li>
                            </ul>
                        </p>

                    </section>
                </div>

                <div class="row row-2">
                    <section>
                        <img class="icon" src={jiosaavn} alt="sanika" />
                        <div class="details">
                            <span class="title" >JioSaavn - Data Analyst Intern <a href="https://drive.google.com/file/d/1g4yEbBZRFThS5BbFz5DK1zUqGDoQ93QG/view?usp=sharing" style={{ color: "#CB9D06" }}>Certificate</a></span>
                            <span className="date">Sept-Dec 2023</span>
                        </div>
                        <p className="timeline_text" style={{ fontSize: "14px", textAlign: "left" }}>
                            <ul>
                                <li>
                                    Worked under the Business Insights team for deriving metrics and performing analysis for diverse stakeholders.
                                </li>
                                <li>
                                    Maintained and created Dashboards for daily, weekly and monthly reporting using Google Looker Studio and Google Sheets.
                                </li>
                                <li>
                                    Fulfilled Ad-hoc queries for feature engagement and deep dive analysis as well as module analysis on the app.
                                </li>
                                <li>
                                    Conducted information retrieval to analyse customer engagement metrics and trends.
                                </li>
                            </ul>
                        </p>
                    </section>
                </div>
                <div class="row row-1">
                    <section>
                        <img class="icon" src={ltim} alt="sanika" />
                        <div class="details">
                            <span class="title">LTIMindtree - Summer Intern <a href="https://drive.google.com/file/d/10cfIGq5_Tkpq1I2gXSIxj555CWZa-UwS/view?usp=sharing" style={{ color: "#CB9D06" }}>Certificate</a></span>
                            <span className="date">Jun-Aug 2023</span>
                        </div>
                        <p className="timeline_text" style={{ fontSize: "14px", textAlign: "left" }}>
                            <ul>
                                <li>
                                    Collaborated with the Data team to analyze support engagements for company services
                                </li>
                                <li>
                                    Conducted data checks on the retrieved data for subsequent processing.
                                </li>
                            </ul>
                        </p>
                    </section>
                </div>
                <div class="row row-2">
                    <section>
                        <img class="icon" src={mathrithms} alt="sanika" />
                        <div class="details">
                            <span class="title">Mathrithms - Frontend Web Developer <a href="https://drive.google.com/file/d/14oBewtvo6lvDJsceo4WTwT4X6l0kQka5/view?usp=sharing" style={{ color: "#CB9D06" }}>LOR</a></span>
                            <span className="date">May-June 2022</span>
                        </div>
                        <p className="timeline_text" style={{ fontSize: "14px", textAlign: "left" }}>
                            <ul>
                                <li>
                                    Worked on Dr. Reddy’s Data Portal by developing web interfaces using MERN stack, GraphQL, Bootstrap.
                                </li>
                                <li>
                                    Successfully refactored portal to improve performance and visualization by 7-10%.
                                </li>
                                <li>
                                    Efficiently followed all SDLC processes right from SRS Documentation to Production Deployment.
                                </li>
                            </ul>
                        </p>

                    </section>
                </div>
            </div>
        </div>
    );
}